import { Directive, Injector, Input, ViewChild, inject } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
} from '@angular/forms';

type ControlAccessorFunction<T = string> = (value: T) => void;

@Directive()
export abstract class ControlValueAccessorConnector<T = string>
  implements ControlValueAccessor
{
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective?: FormControlDirective;

  @Input()
  formControl!: FormControl<T | null>;

  @Input()
  formControlName?: string;

  injector = inject(Injector);

  get control(): FormControl<T | null> {
    return (
      this.formControl ||
      this.controlContainer?.control?.get(this.formControlName || '')
    );
  }

  get controlContainer(): ControlContainer | undefined {
    try {
      return this.injector.get(ControlContainer);
    } catch {
      return undefined;
    }
  }

  registerOnTouched(fn: ControlAccessorFunction<T>): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: ControlAccessorFunction<T>): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: T): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    if (
      this.formControlDirective &&
      this.formControlDirective.valueAccessor &&
      this.formControlDirective.valueAccessor.setDisabledState
    ) {
      this.formControlDirective?.valueAccessor?.setDisabledState(isDisabled);
    }
  }
}
